
import storyblok from '~/mixins/storyblok'

import StoryblokImage from '~/components/StoryblokImage.vue'

export default {
  name: 'Boutique',
  components: { StoryblokImage },
  mixins: [storyblok],
  async asyncData({ $db, $storyblok, error, params }) {
    const story = await $storyblok.getStoryBySlug(
      `${params.ville}/${params.boutique}`
    )
    return {
      story,
      products: await $db.fetch('productsBy', {
        key: 'store',
        param: story.name
      })
    }
  },
  computed: {
    headerLogo() {
      return this.story.headerLogo
    },
    name() {
      return this.story.name
    },
    ville() {
      return this.$route.params.ville.replace('-', ' ')
    }
  },
  created() {
    this.$store.commit('menu/setImage', this.story.headerLogo.filename)
  },
  mounted() {
    this.listenStoryblokChanges(this.story.id, (event) => {
      this.story = event.story.content
    })
  },
  beforeDestroy() {
    this.$store.commit('menu/clear')
  },
  head() {
    return {
      title: `${this.name} - Grand'Rue - ${this.ville}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.story.metaDescription
        }
      ]
    }
  }
}
